import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** Download reservation contract PDF via booking session */
export const useDownloadBookingSessionReservationContractPdfMutation = () =>
  useMutation({
    mutationFn: async (sessionId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/booking-session/${sessionId}/reservation-contract-pdf`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })
